import React from 'react';
import {
  Avatar,
  AvatarGroup,
  Box,
  Icon,
  Skeleton,
  Tooltip,
} from '@mui/material';
import { fileTypeToIconMap } from '../Modals/FileUploadStep';
import { useMemoryByID } from 'hooks/memory/useMemoryByID';
import { RawFileIcon } from 'components/SVG/fileType';
import EditableTitleSkeleton from 'sharedComponents/Skeleton/EditableTitleSkeleton';

type MemoryFileColumnProps = {
  memoryID: string | undefined | null;
  isParentLoading: boolean;
};
function MemoryFileColumn({
  memoryID,
  isParentLoading,
}: MemoryFileColumnProps) {
  const { isLoading, joinedMemory } = useMemoryByID(memoryID, {
    enabled: !isParentLoading && !!memoryID,
  });

  const files = joinedMemory?.files || [];

  if (isLoading)
    return (
      <Skeleton
        variant='rounded'
        sx={{ marginLeft: 1 }}
        width='34px'
        height='44px'
      />
    );

  return (
    <AvatarGroup>
      {files.map((file, index) => (
        <Tooltip
          key={index}
          title={file.attributes.fileName}
          arrow
          placement='top'
        >
          <Box
            sx={{
              '& svg': {
                height: '44px !important',
              },
            }}
          >
            {fileTypeToIconMap[file?.attributes?.fileType] || <RawFileIcon />}
          </Box>
        </Tooltip>
      ))}
    </AvatarGroup>
  );
}

export default MemoryFileColumn;
